(function () {
    'use strict';

    class CalendarPopoverLinkItemComponent extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, AppStates) {
            super($scope, $injector);
            this.__objectType = 'CalendarPopoverLinkItemComponent';
            this.AppStates = AppStates;
        }
    }

    Components.CalendarPopoverLinkItem = {
        bindings: {
            icon: '@',
            link: '<',
            label: '<'
        },
        controller: CalendarPopoverLinkItemComponent,
        name : 'hbCalendarPopoverLinkItem',
        templateUrl: 'angular/app/modules/core/features/calendar/calendar_popover/calendar_popover_link_item.html',
    };

}());

